// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_ur-0";
export var checkoutRateBadgeLink = "_ur-1";